interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  style?: React.CSSProperties;
}

export function Spinner({ size = 'md', className = '', style }: SpinnerProps) {
  const sizeStyles = {
    sm: { width: 16, height: 16 },
    md: { width: 24, height: 24 },
    lg: { width: 40, height: 40 },
  };

  return (
    <div
      className={`spinner ${className}`}
      style={{ ...sizeStyles[size], ...style }}
      role="status"
      aria-label="Loading"
    />
  );
}
